export const useOptions = () => {
    //* 插件
    const i18n = useI18n();
    //* 数据源
    const data = {
        cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/6cc82969-c415-4a63-ae85-aa6c25cf2883.webp",
        video: "https://rdgta.cdn.cyagen.com/rddc/public/c8db58c8e21c1dfb532e7f2f6add1b76.mp4",
        videos: [
            {
                date: "2025-05-27",
                name: "Mutation Direct for Genetic Research",
                href: "https://www.youtube.com/watch?v=MW9w_QcsqHE",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/2e213194-e837-4914-9b39-142a1893e3dc.webp",
            },
            {
                date: "2025-05-21",
                name: "Sequence Analysis Tools",
                href: "https://www.youtube.com/watch?v=Qmg87dUZ7ig",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/9ffa3218-6639-48fb-9abb-f3c94f61b707.webp",
            },
            {
                date: "2025-05-21",
                name: "Master Mutation Effect Prediction: RNA Splicer AI",
                href: "https://www.youtube.com/watch?v=j74Nr-HlAFE",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/558373ef-55df-4a57-9f35-acaa3c4922ac.webp",
            },
            {
                date: "2025-05-21",
                name: "Predicts Genetic Disease Risk in Seconds",
                href: "https://www.youtube.com/watch?v=80LG-yoZnIk",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/a4749484-ccd1-4208-baf8-f787927a8ba7.webp",
            },
            {
                date: "2025-03-31",
                name: "AI Predicts Genetic Disease Risk in Seconds – RDDC Tutorial",
                href: "https://www.youtube.com/watch?v=WmuVSoRcjzA",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/51672add-f45e-4382-a184-b5e0ed237dba.webp",
            },
        ],

        graphics: [
            {
                href: { name: "RnaSplicerTutorials" },
                name: i18n.t("RNASplicer"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/b5024a37-9215-44ee-b921-01f73756247a.webp",
            },
            {
                href: { name: "PathogenicityTutorials" },
                name: i18n.t("VPP"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/4a6ffe0d-d6fb-4569-932d-3a9961f67a3a.webp",
            },
            {
                href: { name: "VariantTutorials" },
                name: i18n.t("MutationViewer"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/070af76e-6aaa-43c2-8274-50bd2bb33887.webp",
            },
            {
                href: { name: "SequenceAlignmentTutorials" },
                name: i18n.t("SequenceAlignment"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/31dc2060-206f-471b-8f1d-f9f8fc9d711b.webp",
            },
            {
                href: { name: "SequenceViewerTutorials" },
                name: i18n.t("SequenceViewer"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/a3400d02-42b4-462c-be1b-84a62bdc5262.webp",
            },
            {
                href: { name: "SequenceProcessorTutorials" },
                name: i18n.t("SequenceProcessor"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/c61a772c-1324-43f3-94d2-909391c59561.webp",
            },
            {
                href: { name: "GeneticComparisonTutorials" },
                name: i18n.t("GeneticComparison"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/40cc31dd-9d70-432a-ad60-fae92635fc00.webp",
            },
            {
                href: { name: "DiseasesComparisonTutorials" },
                name: i18n.t("DiseasesComparison"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/8975d350-3697-4649-b436-97449a270d1d.webp",
            },
            {
                href: { name: "ModelComparisonTutorials" },
                name: i18n.t("ModelComparison"),
                date: "2025-07-01",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/cf7eb1ab-11b4-411e-80c4-1234a80f3b40.webp",
            },
        ],
    };

    //* 中文环境替换资源
    if (i18n.locale.value == "zh") {
        data.video = "https://rdgta.cdn.cyagen.com/rddc/public/2024%20RDDC%E5%AE%A3%E4%BC%A0%E7%89%87%20%E6%9B%B4%E6%96%B00328.mp4";
        data.videos = [
            {
                date: "2025-04-30",
                name: "突变查看器",
                href: "https://www.bilibili.com/video/BV1f4GXzZEL6",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/cdacbe9d-c7d7-4c98-8483-5c50a4d786c8.webp",
            },
            {
                date: "2025-04-30",
                name: "序列分析工具汇总",
                href: "https://www.bilibili.com/video/BV1yVGXzqEQ5",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/9bd3fa5e-41eb-4700-8af0-ed82ef2f8d1f.webp",
            },
            {
                date: "2025-04-28",
                name: "RNA剪接预测模型",
                href: "https://www.bilibili.com/video/BV1m7LCz9EL6",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/d15ae9d4-8321-4d9b-a42e-9ae71483a426.webp",
            },
            {
                date: "2025-04-15",
                name: "致病性预测模型",
                href: "https://www.bilibili.com/video/BV1TcdZY9ERF",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/a369d8c0-578a-4023-ae4f-bed10fb2fb26.webp",
            },
            {
                date: "2025-03-31",
                name: "RDDC罕见病数据中心，全面助力遗传病研究",
                href: "https://www.bilibili.com/video/BV1HAZnYyERH",
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/fee789f4-7876-4536-9fa2-0cd33c08f998.webp",
            },
        ];
    }

    return data;
};
